module.exports = __webpack_public_path__ + "static/media/logo.5f70c2bc.jpeg";